<template>
  <div>
    <mtd-row class="height-64 line-height-64">
      <mtd-col :span="24" class="height-full">
        <mtd-icon-button class="demo-icon-btn" type="secondary" icon="mtdicon mtdicon-arrow-left" @click="back_statement"/>
        <span class="page-head-title" style="margin-left: 12px;">告警通知</span>
      </mtd-col>
    </mtd-row>
    <mtd-row>
      <mtd-col :span="24" class="height-full padding-left-40">
        <mtd-announcement
          title="公告信息"
          type="info"
          show-icon>
          <span>请关注告警内容，我们将持续保障您的数据安全。</span>
        </mtd-announcement>
      </mtd-col>
    </mtd-row>
    <mtd-row class="height-56 line-height-56">
      <mtd-col :span="24" class="height-full padding-left-40">
        <span class="page-second-title">风险概览</span>
      </mtd-col>
    </mtd-row>
<!--    告警数据 remark-->
    <mtd-row style="margin-bottom: 12px">
      <mtd-col :span="24" class="height-full padding-left-40">
        <span v-html="alarm_info.content"></span>
      </mtd-col>
    </mtd-row>
<!--    表格数据-->
    <div  v-for="(item,index) in tables" :key="index">
      <mtd-row class="height-56 line-height-56">
        <mtd-col :span="24" class="height-full padding-left-40">
          <span class="page-second-title">{{ item.table_title }}</span>
          <mtd-button style="float: right;margin-top: 10px" class="btn-demo-item" type="primary" icon="mtdicon mtdicon-export-o" @click="export_to_excel()" v-if="index === 0">导出为Excel</mtd-button>
        </mtd-col>
      </mtd-row>
      <mtd-row>
        <mtd-col class="height-full padding-left-40">
          <mtd-table :data="item.data" size="small" :height="item.risk_height" bordered>
            <mtd-table-column v-for="(column,key) in item.dataMapping" :key="key" :prop="key" :label="column" resizable/>
          </mtd-table>
        </mtd-col>
      </mtd-row>
    </div>
  </div>
</template>

<script>

  import moment from 'moment';
  import {mapActions} from 'vuex'
  import XLSX from 'xlsx'

  export default {
    name: "detail",
    filters: {
      dateTimeFormat(dateTime) {
        if (dateTime) {
          return moment(dateTime)
            .utcOffset(480)
            .format('YYYY-MM-DD HH:mm:ss');
        } else {
          return "";
        }
      }
    },
    computed: {
      login_user() {
        return this.$store.getters.get_login_user;
      },
    },
    data() {
      return {
        alarm_id: this.$route.params.id,
        pageId: this.$route.params.pageId,
        alarm_info: {},
        // 风险概览表格映射和数据
        tables: [],
        // 风险详情表格映射和数据
        risk_details_mapping:{},
        risk_details:[],
        risk_details_show:[],
        currentPage: 1,
        limit: 10,
        risk_height: ''
      }
    },
    mounted: function () {
      this.init_data();
    },
    methods: {
      ...mapActions([
        'api_query_statement_by_id'
      ]),
      change_risk_details(current, size) {
        this.currentPage = current;
        this.limit = size;
        let temp = this.risk_details;
        let start = (this.currentPage - 1) * this.limit;
        let end = this.currentPage * this.limit;
        this.risk_details_show = temp.slice(start,end);
      },
      async init_data() {
        let params = { pageId: this.pageId, id: this.alarm_id };
        let response = await this.api_query_statement_by_id(params);
        this.alarm_info = response.data;
        if (this.alarm_info.tables != null && this.alarm_info.tables.length !== 0) {
          let new_tables = this.alarm_info.tables;
          for (let i = 0; i < new_tables.length; i++) {
            let item = JSON.parse(new_tables[i]);
            if (item.data.length > 10) {
              item.risk_height = '400px';
            }
            this.tables.push(item);
          }
        }
      },
      back_statement() {
        this.$router.push('/statement');
      },
      export_to_excel() {
        // 风险概览的文件
        const wb = XLSX.utils.book_new();
        for (let i = 0; i < this.tables.length; i++) {
          let workSheet = XLSX.utils.json_to_sheet(this.tables[i].data, {header: this.tables[i].dataMapping.keys});
          const range = XLSX.utils.decode_range(workSheet['!ref']);
          for(let c = range.s.c; c <= range.e.c; c++) {
            const header = XLSX.utils.encode_col(c) + '1';
            workSheet[header].v = this.tables[i].dataMapping[ workSheet[header].v ];
          }
          XLSX.utils.book_append_sheet(wb, workSheet, this.tables[i].table_title);
        }
        XLSX.writeFile(wb, "报表数据.xlsx");
      }
    },
  }
</script>

<style>
  .page-head-title {
    font-family: PingFangSC-Medium, sans-serif;
    font-size: 20px;
    color: #333333;
    letter-spacing: 0.5px;
    line-height: 28px;
  }

  .page-head-title-tag {
    font-family: PingFangSC-Regular, sans-serif;
    font-size: 12px;
    line-height: 18px;
    margin-bottom: 6px;
    margin-left: 8px;
  }

  .page-second-title {
    font-family: PingFangSC-Medium, sans-serif;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.87);
    letter-spacing: 0;
    line-height: 22px;
  }

  .padding-left-40 {
    padding-left: 40px;
  }

  .full-block-table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    border: 1px solid rgba(0, 0, 0, 0.06);
  }

  .full-block-table .table-row {
    height: 36px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  }

  .none-height-table>.table-row {
    height: auto !important;
  }

  .full-block-table .table-row td {
    line-height: 36px;
    font-family: PingFangSC-Medium, sans-serif;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.60);
    letter-spacing: 0;
    padding: 0 12px;
    border-right: 1px solid rgba(0, 0, 0, 0.06);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .full-block-table .table-row td.td-title {
    background: #F7F7F7;
    width: 130px;
  }

  .feedback-reason-block {
    background: #F7F7F7;
    border: 1px solid rgba(0, 0, 0, 0.07);
    padding: 15px;
    padding-bottom: 0;
  }
  .full-block-table .table-row td.alarm_info_content{
    white-space: normal;
    line-height: 20px;
  }
</style>
